module.exports = "div.reportingCard {\n  margin-top: 0em; }\n\n.exportCardSpacing {\n  padding: 1rem; }\n"